import { DT_MODE_ISLAND_TYPES as e } from "./mode-island-constants.js";
//#region components/mode_island/validators.js
function t(t) {
	return Object.values(e).includes(t);
}
var n = { modeValidator: t };
//#endregion
export { n as default, t as modeValidator };

//# sourceMappingURL=validators.js.map